import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTasyarBrand } from '../lib/tasyarBrand';
import { XIcon, InstagramIcon, SnapchatIcon, TikTokIcon, YouTubeIcon } from '../components/icons/SocialIcons';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

const SOCIALS = [
  { key: 'twitter_url', label: 'X (تويتر)', Icon: XIcon },
  { key: 'instagram_url', label: 'انستقرام', Icon: InstagramIcon },
  { key: 'snapchat_url', label: 'سناب شات', Icon: SnapchatIcon },
  { key: 'tiktok_url', label: 'تيك توك', Icon: TikTokIcon },
  { key: 'youtube_url', label: 'يوتيوب', Icon: YouTubeIcon },
];

export default function PublicCoachFooter() {
  const navigate = useNavigate();
  const brand = useTasyarBrand();
  const [settings, setSettings] = useState({});

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/platform/settings`).then((res) => setSettings(res.data || {})).catch(() => {});
  }, []);

  const links = SOCIALS.filter((s) => settings[s.key]);

  return (
    <footer className="border-t border-teal-900/30 bg-[#050d18] py-10" dir="rtl" data-testid="coach-public-footer">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-5 px-5 text-center">
        <button onClick={() => navigate('/')} className="flex items-center gap-2" data-testid="coach-public-footer-brand">
          {brand.iconUrl ? (
            <img src={brand.iconUrl} alt={brand.name} className="h-7 w-7 rounded-lg object-contain" />
          ) : (
            <span className="h-7 w-7 rounded-lg bg-teal-500/20" />
          )}
          <span className="font-display text-base font-black text-white">{brand.name} للمدربين</span>
        </button>

        {links.length > 0 && (
          <div className="flex items-center gap-3" data-testid="coach-public-footer-socials">
            {links.map(({ key, label, Icon }) => (
              <a
                key={key}
                href={settings[key]}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                title={label}
                data-testid={`coach-public-footer-social-${key}`}
                className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 bg-white/[0.03] text-slate-400 transition-colors hover:border-teal-500/50 hover:text-teal-400"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        )}

        <div className="flex items-center gap-4 text-xs text-slate-500">
          <a href="/privacy" className="hover:text-slate-300" data-testid="coach-public-footer-privacy-link">سياسة الخصوصية</a>
          <span className="h-1 w-1 rounded-full bg-slate-600" />
          <a href="/terms" className="hover:text-slate-300" data-testid="coach-public-footer-terms-link">الشروط والأحكام</a>
        </div>

        <p className="text-xs font-medium text-slate-500" data-testid="coach-public-footer-copyright">
          © {new Date().getFullYear()} {brand.name} — جميع الحقوق محفوظة
        </p>
      </div>
    </footer>
  );
}
